import React from 'react'
import { Grid } from '@mui/material'


import Text from 'components/Text'
import ToolsCard from 'screens/GetStarted/components/ToolsCard/ToolsCard'

import background from 'assets/img/tools1.png'
import background2 from 'assets/img/tools2.png'
import background3 from 'assets/img/tools3.png'
import background4 from 'assets/img/tools4.png'
import styles from 'screens/ToolsSlider/sections/Section1/Section1.module.css'

const cardData = [
  {
    id: '1',
    label: 'E&R U.S. 500',
    imageUrl: background
  },
  {
    id: '2',
    label: 'E&R U.S. 100',
    imageUrl: background2
  },
  {
    id: '3',
    label: 'Fama & F',
    imageUrl: background3
  },
  {
    id: '4',
    label: 'Sentiment',
    imageUrl: background4
  }
]

export default function Section1() {
  return <div className={styles.container}>
    <Grid xs={12} sm={6} item flexDirection='column' p='100px' >
      <Text size='3.5rem'>
        Sand Box
      </Text>
      <Text size='3.5rem' fontWeight='bold' mb='40px'>
        For Asset Owners
      </Text>
      <Text size='1.875rem'>
        Any asset owner i.e., a pension fund, a family office, an
        endowment, or a sovereign fund can access our code base to
        understand the methodology and test our claim that just by
        changing weights of the components, a basket can be
        systematically outperformed on a risk weighted basis by a
        significant margin.
      </Text>
    </Grid>
    <Grid container xs={12} sm={6} item flexDirection='row'   >
      {cardData.map((card) => {
        return <Grid key={card.id} container item xs={6} justifyContent='center' alignItems='center' p='10px' mt={['3', '4'].includes(card.id) && '50px'}>
          <ToolsCard imageUrl={card.imageUrl} label={card.label} />
        </Grid>
      })}
    </Grid>
  </div >
}
